import { Component } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: [
        Location, {
            provide: LocationStrategy,
            useClass: PathLocationStrategy
        }
    ]
})
export class AppComponent {

    // title = 'Visual Price Estimator';
    // routerSubscription: any;
    // location: any;

    // constructor(
    //     public router: Router,
    //     public toggleService: ToggleService,
    //     @Inject(PLATFORM_ID) private platformId: Object
    // ) {
    //     this.toggleService.isToggled$.subscribe(isToggled => {
    //         this.isToggled = isToggled;
    //     });
    // }

    // // Toggle Service
    // isToggled = false;

    // // Dark Mode
    // toggleTheme() {
    //     this.toggleService.toggleTheme();
    // }

    // // Settings Button Toggle
    // toggle() {
    //     this.toggleService.toggle();
    // }

    // // ngOnInit
    // ngOnInit(){
    //     if (isPlatformBrowser(this.platformId)) {
    //         this.recallJsFuntions();
    //     }
    // }

    // // recallJsFuntions
    // recallJsFuntions() {
    //     this.routerSubscription = this.router.events
    //         .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationCancel))
    //         .subscribe(event => {
    //         this.location = this.router.url;
    //         if (!(event instanceof NavigationEnd)) {
    //             return;
    //         }
    //         this.scrollToTop();
    //     });
    // }
    // scrollToTop() {
    //     if (isPlatformBrowser(this.platformId)) {
    //         window.scrollTo(0, 0);
    //     }
    // }

}
